import { createField } from '@/components/forms/field.schema';
import {
  Building2,
  Calendar,
  FileText,
  Hash,
  KeyRound,
  Link,
  LogIn,
  Mail,
  Power,
  Shield,
  ShieldAlert,
  User,
  UserCircle,
} from 'lucide-react';
import { z } from 'zod';

export const accountFields = {
  recnum: createField(z.number(), {
    fieldType: 'text',
    label: 'Recnum',
    readOnly: true,
    icon: Hash,
  }),
  name: createField(z.string().nullable(), {
    fieldType: 'text',
    label: 'Name',
    placeholder: 'Full name',
    icon: User,
  }),
  loginname: createField(z.string(), {
    fieldType: 'text',
    label: 'Login',
    readOnly: true,
    icon: LogIn,
  }),
  email: createField(z.string().email(), {
    fieldType: 'text',
    label: 'Email',
    readOnly: true,
    icon: Mail,
  }),
  department: createField(z.string().nullable(), {
    fieldType: 'text',
    label: 'Department',
    readOnly: true,
    icon: Building2,
  }),
  relat: createField(z.string(), {
    fieldType: 'text',
    label: 'Relation',
    readOnly: true,
    icon: Link,
  }),
  contact: createField(z.string(), {
    fieldType: 'text',
    label: 'Contact',
    readOnly: true,
    icon: UserCircle,
  }),
  activated: createField(z.boolean(), {
    fieldType: 'boolean',
    label: 'Activated',
    icon: Power,
  }),
  internal: createField(z.boolean(), {
    fieldType: 'boolean',
    label: 'Internal',
    readOnly: true,
    icon: Shield,
  }),
  password_strength: createField(z.number().nullable(), {
    fieldType: 'text',
    label: 'Password Strength',
    readOnly: true,
    icon: KeyRound,
  }),
  last_successful_login: createField(z.string().nullable(), {
    fieldType: 'date',
    label: 'Last Login',
    readOnly: true,
    icon: Calendar,
  }),
  auth_attempts: createField(z.number(), {
    fieldType: 'text',
    label: 'Failed Attempts',
    icon: ShieldAlert,
  }),
  note: createField(z.string().nullable(), {
    fieldType: 'textarea',
    label: 'Notes',
    icon: FileText,
    fullWidth: true,
  }),
};
